import { Controller } from '@hotwired/stimulus'
import EmblaCarousel, { EmblaCarouselType } from 'embla-carousel'

export default class extends Controller {
  static targets = [ 'viewport', 'prevButton', 'nextButton' ]

  declare viewportTarget: HTMLElement
  declare prevButtonTarget: HTMLButtonElement
  declare nextButtonTarget: HTMLButtonElement
  declare hasPrevButtonTarget: boolean
  declare hasNextButtonTarget: boolean

  private embla: EmblaCarouselType | null = null

  connect() {
    this.embla = EmblaCarousel(this.viewportTarget, {
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
      slidesToScroll: 1,
    })

    this.embla.on('select', this.updateButtons)
    this.embla.on('reInit', this.updateButtons)
    this.updateButtons()
  }

  disconnect() {
    this.embla?.destroy()
    this.embla = null
  }

  scrollPrev() {
    this.embla?.scrollPrev()
  }

  scrollNext() {
    this.embla?.scrollNext()
  }

  private updateButtons = () => {
    if (!this.embla) return

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = !this.embla.canScrollPrev()
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = !this.embla.canScrollNext()
    }
  }
}
